import CreateAiSupportedTasksView from "@features/tools/view/ai-supported-tasks-view/create-ai-supported-tasks-view";

const CreateAiSupportedTask = () => {
  return <CreateAiSupportedTasksView />;
};

export default CreateAiSupportedTask;
